var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loginBox"},[_c('div',{staticClass:"loginTitle"},[_vm._v("招商百晓生管理后台")]),_c('div',{staticClass:"loginMain clearfix"},[_c('h1',[_vm._v(_vm._s(_vm.loginText))]),_c('div',{staticClass:"dingdingCode",attrs:{"id":"login_container"}}),_c('div',{staticClass:"registerLink",on:{"click":_vm.toRegister}},[_vm._v("申请管理员权限")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }